import { getPublicConfig } from "@/lib/config/public-config";

// posthog-js may never answer (offline, blocked flags endpoint); waiting
// callers must not wait past this.
export const FLAGS_SETTLE_TIMEOUT_MS = 3000;

let settled = false;
const listeners = new Set<() => void>();

export function markFlagsSettled() {
  settled = true;
  for (const listener of listeners) listener();
}

/** True once flags are answered, or can never be (PostHog not configured, blocked, slow). */
export function featureFlagsSettled() {
  const config = getPublicConfig().posthog;
  return !(config?.enabled && config.apiKey && config.host) || settled;
}

export function subscribeToFlagsSettled(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
